// @flow

import { get } from 'lodash';

import type { AccountPlan } from '@zapier/common-utils';

export default (plan: AccountPlan) =>
  get(plan, 'metered_pricing_tiers', []).map(([numTasks, pricePerTask]) => ({
    numTasks,
    pricePerTask,
  }));
